(() => {
  let currentAudio = null;
  let currentWrap = null;
  const startLock = new WeakMap();

  const fmt = (s) => {
    if (!isFinite(s) || s < 0) return "0:00";
    const m = Math.floor(s / 60);
    const r = Math.floor(s % 60);
    return `${m}:${String(r).padStart(2, "0")}`;
  };

  // ✅ Parse "Label || URL" (works for all posts)
  const parseRaw = (raw) => {
    const s = String(raw || "").trim();
    if (!s) return { label: "", url: "" };

    if (s.includes("||")) {
      const parts = s.split("||");
      return {
        label: parts[0].trim(),
        url: parts.slice(1).join("||").trim(),
      };
    }

    const m = s.match(/https?:\/\/\S+/i);
    return { label: "", url: m ? m[0].trim() : s };
  };

  const setUI = (wrap, playing) => {
    wrap.querySelector(".js-wt-play")?.classList.toggle("hidden", playing);
    wrap.querySelector(".js-wt-pause")?.classList.toggle("hidden", !playing);
    wrap
      .querySelector(".js-wt-toggle")
      ?.setAttribute("aria-label", playing ? "Pause" : "Play");
  };

  const initWrap = (wrap) => {
    const audio = wrap.querySelector(".js-wt-audio");
    if (!audio || audio.dataset.ready) return;

    const { label, url } = parseRaw(wrap.dataset.audioRaw || "");

    // ✅ show label text on the card
    if (label) {
      const labelEl = wrap.closest("article")?.querySelector(".js-audio-label");
      if (labelEl) labelEl.textContent = label;
    }

    // ✅ use URL for audio source
    if (!url) return;
    audio.src = url;

    audio.addEventListener("loadedmetadata", () => {
      wrap.querySelector(".js-wt-dur").textContent = fmt(audio.duration);
    });

    audio.addEventListener("timeupdate", () => {
      const p = audio.duration ? (audio.currentTime / audio.duration) * 100 : 0;
      wrap.querySelector(".js-wt-progress").style.width = `${p}%`;
      wrap.querySelector(".js-wt-knob").style.left = `${p}%`;
      wrap.querySelector(".js-wt-cur").textContent = fmt(audio.currentTime);
    });

    audio.addEventListener("ended", () => {
      setUI(wrap, false);
      wrap.querySelector(".js-wt-progress").style.width = "0%";
      wrap.querySelector(".js-wt-knob").style.left = "0%";
      wrap.querySelector(".js-wt-cur").textContent = "0:00";
    });

    audio.dataset.ready = "1";
  };

  // ✅ Prefetch duration before play (metadata only)
  const prefetchMeta = (wrap) => {
    initWrap(wrap);
    const audio = wrap.querySelector(".js-wt-audio");
    if (!audio || audio.dataset.metaLoaded) return;

    audio.addEventListener(
      "loadedmetadata",
      () => {
        audio.dataset.metaLoaded = "1";
      },
      { once: true },
    );

    audio.load(); // safe here (do NOT call load() inside play click)
  };

  const io = new IntersectionObserver(
    (entries) => {
      entries.forEach((ent) => {
        if (ent.isIntersecting) {
          prefetchMeta(ent.target);
          io.unobserve(ent.target);
        }
      });
    },
    { rootMargin: "250px" },
  );

  document.querySelectorAll(".js-wiretap").forEach((wrap) => io.observe(wrap));

  // ✅ Play/pause + seek for ALL cards
  document.addEventListener(
    "click",
    async (e) => {
      const wrap = e.target.closest(".js-wiretap");
      if (!wrap) return;

      const toggle = e.target.closest(".js-wt-toggle");
      const track = e.target.closest(".js-wt-track");
      if (!toggle && !track) return;

      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      initWrap(wrap);
      const audio = wrap.querySelector(".js-wt-audio");
      if (!audio || !audio.src) return;

      // SEEK
      if (track) {
        const rect = track.getBoundingClientRect();
        const x = Math.min(Math.max(0, e.clientX - rect.left), rect.width);
        const pct = rect.width ? x / rect.width : 0;
        if (isFinite(audio.duration)) audio.currentTime = pct * audio.duration;
        return;
      }

      // TOGGLE
      if (startLock.get(audio)) return;
      startLock.set(audio, true);

      try {
        if (!audio.paused) {
          audio.pause();
          setUI(wrap, false);
          return;
        }

        if (currentAudio && currentAudio !== audio) {
          currentAudio.pause();
          currentAudio.currentTime = 0;
          if (currentWrap) setUI(currentWrap, false);
        }

        currentAudio = audio;
        currentWrap = wrap;

        await audio.play();
        setUI(wrap, true);
      } catch (err) {
        setUI(wrap, false);
        console.log("Play failed:", err);
      } finally {
        startLock.set(audio, false);
      }
    },
    true,
  );
})();
